import {
  CardMembership,
  ContactMail,
  GradeOutlined,
  Settings as SettingsIcon,
  AutoAwesome,
  RateReview,
  Grading,
  Hub,
} from '@mui/icons-material';
import { RESOURCES, ACTIONS } from '../../../hooks/useAccessControl';

export const reportCardMenu = {
  id: 'report-cards',
  label: 'Report Cards',
  icon: CardMembership,
  children: [
    {
      type: 'group',
      id: 'rc-entry',
      label: 'Entry & Comments',
      children: [
        {
          id: 'report-card-subject-comments',
          label: 'Subject Comments',
          icon: ContactMail,
          permission: { resource: RESOURCES.REPORT_CARD.SUBJECT_COMMENTS, action: ACTIONS.READ },
        },
        {
          id: 'report-card-general-comments',
          label: 'General Comments',
          icon: RateReview,
          permission: { resource: RESOURCES.REPORT_CARD.GENERAL_COMMENTS, action: ACTIONS.READ },
        },
        {
          id: 'report-card-student-conduct',
          label: 'Student Conduct',
          icon: GradeOutlined,
          permission: { resource: RESOURCES.REPORT_CARD.CONDUCT, action: ACTIONS.READ },
        },
      ],
    },
    {
      type: 'group',
      id: 'rc-generation',
      label: 'Generation',
      children: [
        {
          id: 'report-card-generation',
          label: 'Generate Reports',
          icon: CardMembership,
          permission: { resource: RESOURCES.REPORT_CARD.REPORT_CARDS, action: ACTIONS.READ },
        },
        {
          id: 'report-card-hub',
          label: 'Assessment Report Hub',
          icon: Hub,
          permission: { resource: RESOURCES.REPORT_CARD.REPORT_CARDS, action: ACTIONS.READ },
        },
      ],
    },
    {
      type: 'group',
      id: 'rc-configuration',
      label: 'Configuration',
      children: [
        {
          id: 'report-card-comment-templates',
          label: 'Comment Templates',
          icon: AutoAwesome,
          permission: { resource: RESOURCES.REPORT_CARD.COMMENT_TEMPLATES, action: ACTIONS.READ },
        },
        {
          id: 'report-card-conduct-categories',
          label: 'Conduct Categories',
          icon: Grading,
          permission: { resource: RESOURCES.REPORT_CARD.CONDUCT, action: ACTIONS.READ },
        },
        {
          id: 'report-card-conduct-ratings',
          label: 'Conduct Ratings',
          icon: GradeOutlined,
          permission: { resource: RESOURCES.REPORT_CARD.CONDUCT, action: ACTIONS.READ },
        },
        {
          id: 'report-card-templates',
          label: 'Report Templates',
          icon: SettingsIcon,
          permission: { resource: RESOURCES.REPORT_CARD.TEMPLATES, action: ACTIONS.READ },
        },
      ],
    },
  ],
};
